import PrefixEnum from '../prefixes'

export default Object.freeze({
    'bootynextlevelbylisa.gymondo.fitness': PrefixEnum.LISA2,
})
